
export default {
  name: 'CatalogItems',

  props: {
    counts: { type: Number, default: 3 },
  },
}
